import { render, staticRenderFns } from "./SideBarDrawer.vue?vue&type=template&id=36054095&scoped=true&"
import script from "./SideBarDrawer.vue?vue&type=script&lang=ts&"
export * from "./SideBarDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./SideBarDrawer.vue?vue&type=style&index=0&id=36054095&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36054095",
  null
  
)

export default component.exports